import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('ExportConfigurationSetFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getConfigurationSetList: function () {
            return $http.get(settings.ApiURL + settings.ConfigurationSetURL);
        },
        getConfigurationSetById: function (id) {
            return $http.get(settings.ApiURL + settings.ConfigurationSetURL + "/" + id);
        },
        exportConfigurationSetByid: function (id) {
            return $http.get(settings.ApiURL + settings.ConfigurationSetURL + "/export/" + id);
        }
    };
}]);

app.controller('ExportConfigurationSetController', ['$q', '$scope', '$parse', 'ExportConfigurationSetFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal',
    function ($q, $scope, $parse, ExportConfigurationSetFactory, $rootScope, settings, masterFactory, $uibModal) {
        $rootScope.pageTitle = "Export TransPac Configuration";
        $scope.configurationSetList = [];
        $scope.ConfigurationSetType = null;
        $scope.DBVersion = null;
        $scope.CompanyName = null;
        $scope.configurationValues = [];
        $scope.selectedConfigurationSetId = null;        
        $scope.error = "";
        $scope.isFormVisible = false;        

        // Initialization - this runs on load
        var init = function () {
            masterFactory.verifyAuthentication();
            $scope.selectedConfigurationSetId = 0;


            $('#loadingModal').modal({ backdrop: 'static' });
            $q.all([
                 ExportConfigurationSetFactory.getConfigurationSetList().success(function (data) {                     
                     $scope.configurationSetList = data;
                 }).error(function (data, status) {
                     masterFactory.setError(status, data, $scope);
                 }),
                 ExportConfigurationSetFactory.getConfigurationSetById(0).success(function (data) {
                     $scope.ConfigurationSetType = data.ConfigurationSetType;
                     $scope.DBVersion = data.DBVersion;
                     $scope.CompanyName = data.CompanyName;
                     $scope.configurationValues = data.ConfigurationValues;
                     $scope.isFormVisible = true;
                 }).error(function (data, status) {
                     $scope.isFormVisible = false;
                     masterFactory.setError(status, data, $scope);
                 })
            ]).then(function () {                
                $('#loadingModal').modal('hide');
            });
        };

        init();

        // On selecting a configuration from left side list
        $scope.onSelectedConfigurationSetChange = function (setId) {
            $scope.closeAlert();            
            $scope.configurationValues = [];
            
            $('#loadingModal').modal({ backdrop: 'static' });
            ExportConfigurationSetFactory.getConfigurationSetById(setId).success(function (data) {
                $scope.ConfigurationSetType = data.ConfigurationSetType;
                $scope.DBVersion = data.DBVersion;
                $scope.CompanyName = data.CompanyName;
                $scope.configurationValues = data.ConfigurationValues;
                    $scope.isFormVisible = true;                   
                }).error(function (data, status) {
                    $scope.isFormVisible = false;
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            
        };

        // Button click functions and submit form function
        $scope.exportConfigurationValues = function (setId) {
            $('#loadingModal').modal({ backdrop: 'static' });
            ExportConfigurationSetFactory.exportConfigurationSetByid(setId).success(function (data, status, headers) {
                headers = headers();

                var filename = headers['x-filename'];
                if(filename == null) filename = "ConfigurationSet.json";
                var contentType = headers['content-type'];
                if(contentType == null) contentType = "application/json";
                var linkElement = document.createElement('a');
                try {
                    var jsonString = JSON.stringify(data, null, 2);
                    var blob = new Blob([jsonString], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Export successful.' });
            }).error(function (data, status) {
                $scope.isFormVisible = false;
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };
       
        // Helping functions and events
        $scope.closeAlert = function () {
            $scope.error = null;
        };        

        $scope.viewComplexConfigValue = function (configurationValue, configTypeToDisplay) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                templateUrl: 'app-legacy/Entities/templates/complexConfigurationModal_export.html',
                controller: 'ComplexConfigurationModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    ComplexConfigurationValue: function () {
                        configurationValue.deviceId = null;
                        configurationValue.driverId = null;
                        if (configTypeToDisplay == 'DEFAULT') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.DefaultXmlSchema);
                        }
                        else if (configTypeToDisplay == 'GROUP') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.GroupXmlSchema);
                        }
                        return configurationValue;
                    }
                }
            });
        };

    }]);

app.controller('ComplexConfigurationModalController', ['$scope', '$uibModalInstance', 'ComplexConfigurationValue', '$filter', '$uibModal',
    function ($scope, $uibModalInstance, ComplexConfigurationValue, $filter, $uibModal) {
        var modalVm = this;

        init();

        modalVm.cancel = function () {
            $uibModalInstance.close('ok');
        };

        modalVm.formSelected = function (index) {
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsAddNew = false;
            modalVm.MultiFormSettings.selectedFormIndex = index;
        };

        function init() {
            modalVm.ActiveTab = 0;
            modalVm.SortedSelectedList = {};
            modalVm.ComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ResetComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsSingle = modalVm.ComplexConfigurationValue.XmlSchema.isSingle;
            if (!modalVm.IsSingle) { // multi form settings
                modalVm.MultiFormSettings = {
                    newForm: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.splice(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.length - 1, 1)),
                    stagingComplexConfig: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence),
                    selectedFormIndex: 0
                };
            }
        };
    }]);